import React from 'react';
import { string, shape, func, bool, number } from 'prop-types';

import Dropdown from 'ps-components/Dropdown/Dropdown';

import './PayElementDropdown.scss';

class PayElementDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.handleElementClick = this.handleElementClick.bind(this);
  }

  static propTypes = {
    payElements: shape({
      baseSalary: string,
      totalCash: string,
      totalTargetCash: string,
      totalDirect: string,
      totalGuaranteedPay: string,
      totalEmployeeCounts: number,
      totalCompanyCounts: number
    }),
    selectedPayElement: string,
    onElementClick: func,
    label: string,
    showOverallComposites: bool
  };

  getDropdownItems() {
    const { payElements, showOverallComposites } = this.props;

    return showOverallComposites
      ? [
          payElements.baseSalary,
          payElements.totalCash,
          payElements.totalTargetCash,
          payElements.totalDirect,
          payElements.totalGuaranteedPay
        ]
      : [
          payElements.baseSalary,
          payElements.totalCash,
          payElements.totalTargetCash,
          payElements.totalDirect,
          payElements.totalGuaranteedPay,
          payElements.totalEmployeeCount,
          payElements.totalCompanyCount
        ];
  }

  handleElementClick(e) {
    const { onElementClick } = this.props;

    if (e.includes('Base Salary')) onElementClick('baseSalary');
    else if (e.includes('Total Cash')) onElementClick('totalCash');
    else if (e.includes('Total Target Cash')) onElementClick('totalTargetCash');
    else if (e.includes('Total Direct')) onElementClick('totalDirect');
    else if (e.includes('Total Guaranteed Pay')) onElementClick('totalGuaranteedPay');
    else if (e.includes('Total Employee Count')) onElementClick('totalEmployeeCount');
    else if (e.includes('Total Company Count')) onElementClick('totalCompanyCount');
  }

  render() {
    const dropdownItems = this.getDropdownItems();
    const { selectedPayElement, payElements, label } = this.props;

    return (
      <div className="pay-elements-selector">
        <p className="pxl-text-xsmall pay-elements-selector__label">{label || 'Pay Element at Target'}</p>
        <Dropdown
          btnClass="btn-default"
          className="pay-element-dropdown"
          dropdownClass="pay-element-dropdown__items"
          id="dropdown-1"
          text={payElements[selectedPayElement]}
          itemOnClick={this.handleElementClick}
          dropdownItems={dropdownItems}
        />
      </div>
    );
  }
}

export default PayElementDropdown;
